(() => {
  function cups(value) {
    return value.split(/\s*cups?/i)[0].trim().split(/\s+/).reduce((total, part) => {
      const f = part.split('/').map(Number);
      return total + (f.length === 2 ? f[0] / f[1] : f[0]);
    }, 0);
  }
  function setup() {
    document.querySelectorAll('select[aria-label="Scoop size"]').forEach(select => {
      if (select.dataset.capacityGuide) return;
      select.dataset.capacityGuide = 'true';
      const choices = Array.from(select.options).map(option => ({option, cups:cups(option.value)})).filter(item => Number.isFinite(item.cups) && item.cups > 0);
      if (!choices.length) return;
      const max = Math.max(...choices.map(item => item.cups));
      const guide = document.createElement('details'); guide.className = 'paws-capacity-guide';
      const summary = document.createElement('summary'); summary.textContent = 'Compare scoop capacities';
      const help = document.createElement('p'); help.textContent = 'Compare volume, then choose a size. Bars show capacity, not physical dimensions. Use your pet’s usual serving amount.';
      const list = document.createElement('ul'); list.setAttribute('aria-label', 'Available scoop capacities');
      const buttons = [];
      choices.forEach(item => {
        const row = document.createElement('li');
        const button = document.createElement('button'); button.type = 'button';
        const label = document.createElement('span'); label.textContent = item.option.value.split(/\s*[-–]\s*/)[0];
        const track = document.createElement('span'); track.className = 'paws-capacity-track'; track.setAttribute('aria-hidden','true');
        const fill = document.createElement('span'); fill.style.width = (item.cups / max * 100) + '%'; track.append(fill);
        const volume = document.createElement('span'); volume.textContent = Number((item.cups * 8).toFixed(2)) + ' fl oz';
        button.append(label, track, volume); row.append(button); list.append(row);
        button.addEventListener('click', () => {select.value = item.option.value; select.dispatchEvent(new Event('change', {bubbles:true}));});
        buttons.push({button, option:item.option});
      });
      const note = document.createElement('p'); note.className = 'paws-capacity-note'; note.textContent = 'US measurements: 1 cup = 8 fl oz. Fluid ounces measure volume, not the weight of kibble.';
      guide.append(summary, help, list, note);
      select.closest('fieldset').append(guide);
      function update() {buttons.forEach(({button, option}) => {button.disabled = option.disabled; button.setAttribute('aria-pressed', String(select.value === option.value));});}
      select.addEventListener('change', update); update();
      new MutationObserver(update).observe(select, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','selected']});
      const picker = select.closest('variant-radios,variant-selects');
      if (picker) new MutationObserver(update).observe(picker, {attributes:true, attributeFilter:['aria-busy']});
    });
  }
  document.addEventListener('DOMContentLoaded', setup, {once:true});
  if (document.readyState === 'complete') setup();
})();